import '../../styles/read-more-button.css';

import { _ } from '../../utils/l10n';
import PlusIcon from '../../assets/icons/plus-primary.svg';

export interface ReadMoreButtonProps {
  /**
   * Indicates if read more is open
   */
  isOpen: boolean;
  /**
   * Action to be performed on click
   */
  onClick: () => void;
}

export const ReadMoreButton = (
  {
    isOpen,
    onClick,
  }: ReadMoreButtonProps,
) => {
  return (
    <button
      className={`read-more-button ${isOpen ? 'open' : ''}`}
      onClick={onClick}
    >
      <div className='read-more-button-icon-container'>
        <img src={PlusIcon} alt="" />
      </div>
      {isOpen ? _('Read less') : _('Read more')}
    </button>
  );
};
